import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import SignInModal from './SignInModal';
import { withTranslation } from 'react-i18next';


class Login extends Component {
    state = {
        isOpen: false
    }

    render() {
        const { isOpen } = this.state;
        const { t } = this.props;

        return (
            <div className="login">
                <Container>
                    <h2>{t('logInRequired', { ns: 'common' })}</h2>
                    <div className="btn-box">
                        <Link to="/" className="btn">{t('toStartPage', { ns: 'common' })}</Link>
                        <div className="btn" onClick={() => this.setState({ isOpen: !isOpen })}> {t('logIn', { ns: 'common' })}</div>
                    </div>
                </Container>
                {isOpen &&
                    <SignInModal
                        header={t('logIn', { ns: 'common' })}
                        isOpen={isOpen}
                        toggleModal={() => this.setState({ isOpen: !isOpen })}
                    />}
            </div>
        );
    }
}

export default withTranslation('common')(Login);
